function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "var(--primary-color, #000)",
  fill: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.726 47.622c-1.117-.134-1.091-.648-3.478-1.841-2.234-1.117-.708 5.779 1.194 7.398 7.679-.238 17.899.1 17.899.1-3.809-.18-8.877-1.782-11.643-8.191 0 0-2.011 2.77-3.972 2.534zM45.683 47.622c1.117-.134 1.091-.648 3.478-1.841 2.234-1.117.708 5.779-1.194 7.398-7.679-.238-17.899.1-17.899.1 3.932-.18 8.877-1.782 11.643-8.191 0 0 2.011 2.77 3.972 2.534z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.484 15.95a13.723 10.739 0 01-13.723 10.739A13.723 10.739 0 0115.038 15.95 13.723 10.739 0 0128.761 5.211 13.723 10.739 0 0142.484 15.95z",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.789 11.048a2.387 3.58 27.871 00-2.932 2.24 2.387 3.58 27.871 00.436 4.281 2.387 3.58 27.871 003.783-2.049 2.387 3.58 27.871 00-.436-4.28 2.387 3.58 27.871 00-.851-.192zm-.165 1.993a1.455 1.455 0 01.07 0 1.455 1.455 0 011.454 1.454 1.455 1.455 0 01-1.455 1.454 1.455 1.455 0 01-1.454-1.454 1.455 1.455 0 011.385-1.454zM32.689 11.048a3.58 2.387 62.129 012.932 2.24 3.58 2.387 62.129 01-.436 4.281 3.58 2.387 62.129 01-3.783-2.049 3.58 2.387 62.129 01.436-4.28 3.58 2.387 62.129 01.851-.192zm.165 1.993a1.455 1.455 0 00-.07 0 1.455 1.455 0 00-1.454 1.454 1.455 1.455 0 001.455 1.454 1.455 1.455 0 001.454-1.454 1.455 1.455 0 00-1.385-1.454zM21.323 7c-1.43.767-4.093 2.586-4.887 4.176-1.014 2.033-3.34-1.87-3.34-4.176 0-2.307 1.841-4.176 4.113-4.176S23.356 5.91 21.323 7zM36.576 7c1.43.767 4.093 2.586 4.887 4.176 1.014 2.033 3.34-1.87 3.34-4.176 0-2.307-1.841-4.176-4.113-4.176-2.272 0-6.147 3.086-4.114 4.176z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 28.653,
  cy: 18.029,
  rx: 1.193,
  ry: 0.307
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  stroke: "var(--primary-color, #000)",
  fill: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.954 21.916c1.378 1.12 3.092 0 3.58-3.58.411 3.621 2.896 4.85 4.17 3.58",
  fill: "none",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.447 25.839c5.08 2.2 8.634 7.258 8.634 13.146 0 7.908-6.411 14.319-14.32 14.319-7.908 0-14.318-6.411-14.318-14.319 0-5.84 3.495-10.863 8.508-13.091",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.95 25.894c-5.5.725-10.249 3.932-9.93 10.341-.309 2.383 4.448 9.284 8.354 7.16 2.881-1.567-.199-12.301 2.386-14.32 2.508-1.958 7.038-1.958 9.547 0 2.585 2.02-.546 12.85 2.386 14.32 4.318 2.164 8.778-6.436 8.353-7.16.302-5.265-3.256-10.429-9.6-10.396-3.95 1.067-7.792 1.18-11.496.055",
  fillRule: "evenodd"
}));

var SvgPanda = function SvgPanda(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPanda, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Panda.01a4a9fb.svg";
export { ForwardRef as ReactComponent };